import React,{useState, useEffect, Fragment} from 'react'
import axios from 'axios';
import Radio from  './Radio.js'; 
import { association, officials,rules, officialtest } from "../../apis/urls";
import Userimg2 from '../../assets/userimg.png'


import { Navigate, useNavigate, Link, useParams } from "react-router-dom";
import { wait } from '@testing-library/user-event/dist/utils/index.js';
import Certificate from '../../common-components/Certificate.js';
import { TestCertificate } from '../../common-components/Certificate.js';
import { message, Progress, Spin } from 'antd';
import { $ } from "react-jquery-plugin";
import { Grid } from '@nextui-org/react';
import { decode } from 'html-entities';




const Questions = () => {
    const [ruleid, setRuleid] = useState([]);
    const { id } = useParams();
    const { oid, rid } = useParams();
    let coachId = localStorage.getItem('coachid');

    const abcd = ["A", "B", "C", "D"];
    const color = ["linear-gradient(to right, #0072ff, #00c6ff)", "linear-gradient(to right, #0072ff, #00c6ff)", 
        "linear-gradient(to right, #0072ff, #00c6ff)", "linear-gradient(to right, #0072ff, #00c6ff)"];

    useEffect(() => {
        $('body').removeClass('').addClass('sidebar-collapsed');
        officialTest();
    }, []);

    const [totalMark, setTotalMark] = useState('');
    const [ruleData, setRuleData] = useState('');
    const [usermarks, setUsermarks] = useState('');
    const [totalmarks, setTotatlMarks] = useState('');
    const [minmarks, setMinmarks] = useState('');
    const [showInstructions, setShowInstructions] = useState(true); // New state for instructions

    let navigate = useNavigate();


    // const tryagain = () => {
    //     navigate('/questions_select/'+rid+"/"+oid);
    // }

    // const home = () => {

    //     navigate('/questions_select/'+rid+"/"+oid);

    // }

    const download = e => {
        console.log(e.target.href);
        fetch(e.target.href, {
          method: "GET",
          headers: {}
        })
          .then(response => {
            response.arrayBuffer().then(function(buffer) {
              const url = window.URL.createObjectURL(new Blob([buffer]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "certificate.pdf"); //or any other extension
              document.body.appendChild(link);
              link.click();
            });
          })
          .catch(err => {
            console.log(err);
          });
    };




    const [score, setScore] = useState(0);
    const [selected, setSelected] = useState('');
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [showScore, setShowScore] = useState(false);
    const [prevButton, setPrevButton] = useState(false);
    const [isanswerCorrect, setIsAnswerCorrect] = useState(false);
    const [result, setResult] = useState('');
    const [dwdcerti, setDwdcerti] = useState(false);
    const [cur, setCur] = useState(0);
    const [ansSelect, setAnsSelect] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); //
    let coachName = localStorage.getItem('coachname');

    const officialTest = async () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        let coachId = localStorage.getItem('coachid')
        console.log(rid);

        const instance = axios.create({
            
            baseURL: officialtest+rid,

            timeout: 1000000,
            
            headers: {'authorization': token,'coachId': coachId}
        
          });

        
          
         await instance.get('').then((response) =>{   

            console.log(response)
            setResult(response.data.data);
            setRuleData(response.data.ruleData)
            setTotalMark(response.data.totalMark)
            // setType(response.data.data[currentQuestion].type)
            // setQueid(response.data.data[currentQuestion].id)

          }).catch((error) =>{
            
            console.log('error',error.message)
             

          });

    }




    const TestSubmiting = async () => {
       
        if (!ansSelect[cur]) {
            alert('Please select answer');
            return;
        }
    
        // Check if all questions have been answered
        if (ansSelect.length < result.length) {
            alert('Please answer all questions before submitting.');
            return;
        }

        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);
         
        let token = "Bearer "+localStorage.getItem('token');
        const data = {
            answers: ansSelect
        }
        
        const instance = axios.create({
            
            baseURL: officialtest+"submit/"+rid+"/"+coachId,

            timeout: 1000000,

            headers: {'authorization': token}
        
          });

        await instance.post('',data).then((response) =>{   

            localStorage.setItem('passstatus', JSON.stringify(response.data))

            if(response.data.message === 'passed' || response.data.message === 'failed')
            {
                navigate('/quiz/message?message')
            }
         
           

          }).catch((error) =>{

            setIsSubmitting(false);
            console.log('error',error.message)
             

        });
    };

    const NextButton = () => {
        if (ansSelect[cur]) {
            setCur(cur + 1);
        } else {
            alert('Please select answer');
        }
    };

    const PrevButton = () => {
        setCur(cur - 1);
    };

    const SelectAnswer = (item, qst, qid, type, aid) => {
        if (ansSelect[cur]) {
            const values = [...ansSelect];
            ansSelect[cur].select = item;
            setAnsSelect(setAnsSelect);
            setAnsSelect(values);
        } else {
            let newArr = [];
            let arrDatas = {
                select: item,
                qst: qst,
                qid: qid,
                type: type,
                aid: aid
            };
            newArr = [...ansSelect, arrDatas];
            setAnsSelect(newArr);
            console.log(newArr);
        }
    };

    let token = "Bearer "+localStorage.getItem('token');
    let tokens = localStorage.getItem('token');
    let resetPassword = () => {
        navigate('/reset_password')
    }
    const Logout = () => {
        let urole = localStorage.getItem('userrole');

        localStorage.removeItem('coachlogin');
        if(urole === 'SUPERADMIN'){
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('userid');
            localStorage.removeItem('userrole');
            localStorage.removeItem('test_attempted')
            localStorage.removeItem('association')
            localStorage.removeItem('coachId')

           
            navigate("/admin")

        }else{
        let store = localStorage.getItem('token');
        // console.log('key',store)
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')
        localStorage.removeItem('association')

        
        navigate("/rules_list", { replace: true });
        }
        //window.location.href = "gisa/";
      }
      
      

    return (
        <div className="wrapper">
            <aside className="right-side ">
            {
                tokens?
            (<header>
				<div className="title-and-userprofile-wrpr" >
                    <div>
                        
                    </div>
					<div className="user-profile-wrpr nav navbar-nav">
						<div className="navbar-collapse">
                            <div className="navbar">
                            
                                <ul className="nav user-profile navbar-nav ml-auto text-right">
                                    <ul className="nav-item user-avatar-items dropdown">
                                        <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/aaa">
                                                        
                                            <div className="username-and-type">
                                                <span className="loggedinuser">
                                                    <i className="icon-userimage"></i> <span className="username">User</span>
                                                </span>
                                                <span className="usertype">{coachName}</span>
                                            </div>
                                            <div className="profile-pic">
                                                <img src={Userimg2} width="" height="" alt="" />
                                            </div>
                                                            
                                        </a>	

                                        <div className="dropdown-menu dropdown-menu-right">
                                            <button className="dropdown-item" onClick={ resetPassword }>Reset Password</button>
                                            <button onClick={Logout} className="dropdown-item" href="#">Logout</button>											
                                        </div>
                                    </ul>
                                </ul>
                            </div>
                        </div> 
                    </div>
                </div>
			</header> ) : null
            }

                <div className="content-area">
                    {showInstructions ? (
                        <div style={{ width: '60%', margin: '0 auto', padding: 20, background: '#fff', borderRadius: 15 }}>
                            <h2>Instructions</h2>
                            <div dangerouslySetInnerHTML={{ __html: decode(ruleData.instructions) }} />
                            <button
                                className="btn-qst"
                                style={{ background: '#000', padding: 20, width: '30%', borderRadius: 10, color: '#fff', fontWeight: 800, fontSize: 18, marginTop: 20 }}
                                onClick={() => setShowInstructions(false)}
                            >
                                Start Test
                            </button>
                        </div>
                    ) : (
                        result.length !== 0 ? (
                            <Fragment>
                                <div className='container-quiz' style={{ width: '60%', margin: "0 auto" }}>
                                    <div className='row'>
                                        <div className='col-md-12' style={{ background: '#fff', marginTop: 20, padding: 10, borderRadius: 15 }}>
                                            <div className='row'>
                                                <div className='col-md-10' style={{ display: 'flex', alignSelf: 'center' }}>
                                                    <h1 style={{ textAlign: 'left', fontWeight: 900, justifyContent: 'center', marginTop: 10, textTransform: 'uppercase', padding: 10, color: 'grey', fontFamily: 'Poppins', paddingLeft: 20 }}>
                                                        {decode(ruleData.rule_name)}
                                                    </h1>
                                                </div>
                                                <div className='col-md-2 progress-qst' style={{ textAlign: 'center' }}>
                                                    <Progress type="circle" width={100} percent={(ansSelect.length / result.length * 100).toFixed(2)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-12' style={{ background: '#fff', marginTop: 20, borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                                            <h6 style={{ textAlign: 'left', paddingTop: 20, paddingBottom: 10, fontSize: 18, fontWeight: 900, padding: 30 }}>
                                                Question {cur + 1}/{result.length} <span style={{ float: 'right' }}>MARK : {totalMark}</span>
                                            </h6>
                                            <h2 style={{ paddingBottom: 10, paddingLeft: 30, paddingRight: 30, textAlign: 'center', fontWeight: 600 }}>
                                                {decode(result[cur].question)}
                                            </h2>
                                        </div>
                                        <div className='col-md-12' style={{ background: '#fff', paddingLeft: 70, paddingRight: 70, paddingBottom: 70, paddingTop: 10, borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }}>
                                            {result[cur].type === "BOOLEAN" ?
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div
                                                            style={{
                                                                background: ansSelect[cur] ? ansSelect[cur].select === 'TRUE' ? color[0] : '#f0f0f0' : '#f0f0f0',
                                                                padding: 20, marginTop: 10, borderRadius: 10, fontWeight: 700, fontSize: 18, cursor: 'pointer',
                                                                color: ansSelect[cur] ? ansSelect[cur].select === 'TRUE' ? '#fff' : '#000' : '#000'
                                                            }}
                                                            onClick={() => { SelectAnswer("TRUE", result[cur].question, result[cur].id, result[cur].type, result[cur].answer_id) }} >
                                                            <span style={{
                                                                padding: 7, borderRadius: 30, width: 40,
                                                                background: ansSelect[cur] ? ansSelect[cur].select === 'TRUE' ? '#fff' : '#000' : '#000',
                                                                color: ansSelect[cur] ? ansSelect[cur].select === 'TRUE' ? '#000' : '#fff' : '#fff',
                                                                height: 40, display: 'inline-block', textAlign: 'center'
                                                            }}>
                                                                A
                                                            </span>
                                                            <span style={{ paddingLeft: 10 }}>TRUE</span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div
                                                            style={{
                                                                background: ansSelect[cur] ? ansSelect[cur].select === 'FALSE' ? color[1] : '#f0f0f0' : '#f0f0f0',
                                                                padding: 20, marginTop: 10, borderRadius: 10, fontWeight: 700, fontSize: 18, cursor: 'pointer',
                                                                color: ansSelect[cur] ? ansSelect[cur].select === 'FALSE' ? '#fff' : '#000' : '#000'
                                                            }}
                                                            onClick={() => { SelectAnswer("FALSE", result[cur].question, result[cur].id, result[cur].type, result[cur].answer_id) }} >
                                                            <span style={{
                                                                padding: 7, borderRadius: 30, width: 40,
                                                                background: ansSelect[cur] ? ansSelect[cur].select === 'FALSE' ? '#fff' : '#000' : '#000',
                                                                color: ansSelect[cur] ? ansSelect[cur].select === 'FALSE' ? '#000' : '#fff' : '#fff',
                                                                height: 40, display: 'inline-block', textAlign: 'center'
                                                            }}>
                                                                B
                                                            </span>
                                                            <span style={{ paddingLeft: 10 }}>FALSE</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className='row'>
                                                    {result[cur].options.map((item, index) => (
                                                        <div className='col-md-6'>
                                                            <div
                                                                style={{
                                                                    background: ansSelect[cur] ? ansSelect[cur].select === item ? color[index] : '#f0f0f0' : '#f0f0f0',
                                                                    padding: 20, marginTop: 10, borderRadius: 10, fontWeight: 700, fontSize: 18, cursor: 'pointer', marginBottom: 20,
                                                                    color: ansSelect[cur] ? ansSelect[cur].select === item ? '#fff' : '#000' : '#000'
                                                                }}
                                                                onClick={() => { SelectAnswer(item, result[cur].question, result[cur].id, result[cur].type, result[cur].answer_id) }} >
                                                                <span style={{
                                                                    padding: 7, borderRadius: 30, width: 40,
                                                                    background: ansSelect[cur] ? ansSelect[cur].select === item ? '#fff' : '#000' : '#000',
                                                                    color: ansSelect[cur] ? ansSelect[cur].select === item ? '#000' : '#fff' : '#fff',
                                                                    height: 40, display: 'inline-block', textAlign: 'center'
                                                                }}>
                                                                    {abcd[index]}
                                                                </span>
                                                                <span style={{ paddingLeft: 10 }}>{item}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        </div>
                                        <div className='col-md-12' style={{ background: 'transparent', marginTop: 20, padding: 10 }}>
                                            <div className='row'>
                                                <div className='col-md-6 question-btn' style={{ padding: 20, textAlign: 'left' }}>
                                                    <button
                                                        className='btn-qst'
                                                        style={{ background: '#fff', padding: 20, width: "60%", borderRadius: 10, fontWeight: 800, fontSize: 18, outline: 'red' }}
                                                        onClick={() => PrevButton()} disabled={cur === 0 ? true : false}>
                                                        {cur === 0 ? 'Previous' : 'Previous'}
                                                    </button>
                                                </div>
                                                <div className='col-md-6 question-btn' style={{ padding: 20, textAlign: 'right' }}>
                                                    <button className='btn-qst'
                                                        style={{ background: '#000', padding: 20, width: "60%", borderRadius: 10, color: '#fff', fontWeight: 800, fontSize: 18 }}
                                                        onClick={() => result.length === cur + 1 ? TestSubmiting() : NextButton()}>
                                                        {result.length === cur + 1 ? (isSubmitting ? 'Submitting...' : 'Submit') : 'Next'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        ) : (
                            <div>Sorry! No Questions available</div>
                        )
                    )}
                </div>
            </aside>
        </div>
    );
}

export default Questions;
